export const CLEAR_CURRENT_ERROR = "CLEAR_CURRENT_ERROR";
export const CLEAR_NOTIFICATION = "CLEAR_NOTIFICATION";